// Dependencies
import React from "react";
import PropTypes from "prop-types";
import { graphql, useStaticQuery } from "gatsby";

// Components
import { OfficeCard } from "../../components/NewsCards";

// Helpers
import Container from "../../components/containers/Container";

const OfficesGrid = () => {
  const {
    craft: { entries },
  } = useStaticQuery(graphql`
    query OfficesQuery {
      craft {
        entries(section: "offices", orderBy: "postDate") {
          ... on craft_offices_default_Entry {
            title
            businessName
            address
            postalCode
            city
            email
            phoneOne
            phoneTwo
            redactor
            linkAddress
            linkName
            highlightImage {
              url
            }
          }
        }
      }
    }
  `);

  return (
    <Container className="pt-2 md:pt-10 xl:pt-24">
      <div className="flex-grow space-y-16 lg:space-y-0 lg:grid grid-cols-3 lg:grid-rows-2 lg:gap-x-8 gap-y-20">
        {entries.map((office, index) => {
          return (
            <OfficeCard
              key={index}
              office={office}
              className={index === 0 ? "row-span-2" : ""}
            />
          );
        })}
      </div>
    </Container>
  );
};

OfficesGrid.propTypes = {
  offices: PropTypes.object,
};

export default OfficesGrid;
